import { render, staticRenderFns } from "./CharacterCreatePage.vue?vue&type=template&id=3d10d43e&scoped=true"
import script from "./CharacterCreatePage.vue?vue&type=script&lang=ts"
export * from "./CharacterCreatePage.vue?vue&type=script&lang=ts"
import style0 from "./CharacterCreatePage.vue?vue&type=style&index=0&id=3d10d43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10d43e",
  null
  
)

export default component.exports